/**
 * 模块 - 订阅卡管理 - 英文
 */
export default {
  subscriptionCard: {
    applySubReturn: 'Apply Subscription Card Return',
    copyCardNo: 'Copy Card No.',
    copyCardPassword: 'Copy Card Password',
    returnCard: 'Return Card',
    extendValidity: 'Extend Validity',
    markValid: 'Mark Valid',
    void: 'Void',
    cardPassword: 'Subscription Card Password',
    agentId: 'Agent ID',
    agentName: 'Agent Name',
    cardType: 'Card Type',
    cardNo: 'Card No.',
    cardStatus: 'Status',
    used: 'Used',
    voided: 'Voided',
    returnCardDialog: 'Subscription Card Return',
    confirm: 'Confirm',
    extendValidityConfirm: 'Are you sure you want to extend the subscription card validity by 30 days?',
    voidConfirm: 'Are you sure you want to void this subscription card?',
    markValidConfirm: 'Are you sure you want to mark this subscription card as valid?',
    fissionPayAmount: 'Fission Pay Amount',
    fissionReturnAmount: 'Fission Return Amount',
    cashPayAmount: 'Cash Pay Amount',
    returnType: 'Return Type',
    pleaseSelectReturnAccount: 'Please select return account',
    agentCashAccount: 'Agent Cash Account',
    cashReturnAmount: 'Cash Return Amount',
    returnArrivalDate: 'Return Arrival Date',
    // search form config
    agent: 'Agent',
    pleaseSelectAgent: 'Please select agent',
    cardStatusLabel: 'Card Status',
    pleaseSelectCardStatus: 'Please select card status',
    pleaseEnterCardNo: 'Enter card no.',
    buyTime: 'Purchase Date',
    buyTimeColumn: 'Purchase Time',
    validTime: 'Valid Date',
    returnApplyStatus: 'Return Apply Status',
    returnApplyStatusColumn: 'Return Apply Status',
    pleaseSelectReturnApplyStatus: 'Please select return apply status',
    cannotApply: 'Cannot Apply',
    pendingApply: 'Pending',
    applied: 'Applied',
    purchaseNo: 'Purchase Order No.',
    pleaseEnterPurchaseNo: 'Enter purchase order no.',
    // return card exit text
    exitTextUsed: 'The following subscription cards were issued from the same purchase order. Some cards have been used and cannot be returned.',
    exitTextRelation: 'The following subscription cards were issued from the same purchase order. Once returned, they cannot be used again and the payment will be refunded to the corresponding account. Confirm to return?',
    exitTextSingle: 'Once this subscription card is returned, it cannot be used again and the payment will be refunded to the corresponding account. Confirm to return?',
    applySuccess: 'Application submitted successfully!',
    copyFail: 'Copy failed!',
    viewFail: 'View failed',
    extendSuccess: 'Extended successfully',
    extendFail: 'Extension failed',
    voidSuccess: 'Voided successfully',
    voidFail: 'Void failed',
    markValidSuccess: 'Marked valid successfully',
    markValidFail: 'Mark valid failed',
    cancelSuccess: 'Cancelled successfully',
    cancelFail: 'Cancel failed',
    consumeNo: 'Consume Serial No.',
    pleaseEnterConsumeNo: 'Enter consume serial no.',
    useDate: 'Use Date',
    to: 'to',
    learningMachineAccount: 'Learning Machine Account',
    pleaseEnterLearningMachineAccount: 'Enter learning machine account',
    cardAgent: 'Card Agent',
    pleaseSelectCardAgent: 'Select card agent',
    machineAgent: 'Machine Agent',
    pleaseSelectMachineAgent: 'Select machine agent',
    cardAgentId: 'Card Agent ID',
    cardAgentName: 'Card Agent Name',
    machineAgentId: 'Machine Agent ID',
    machineAgentName: 'Machine Agent Name',
    useTime: 'Use Time',
    useOperator: 'Use Operator',
    renewRegion: 'Renew Region',
    renewLevel: 'Renew Level',
    renewMonthNum: 'Renew Month Qty',
    songguoSubscriptionCard: 'Songguo Subscription Card',
    subscriptionCard: 'Subscription Card'
  }
}
